define("ember-composable-helpers/utils/is-object", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = isObject;
  function isObject(val) {
    return (0, _utils.typeOf)(val) === 'object' || (0, _utils.typeOf)(val) === 'instance';
  }
});